<template>
  <div :class="$style.container">
    <span :class="$style.header">{{ $t('checkout.basket.empty.header') }}</span>
    <p :class="$style.text">{{ $t('checkout.basket.empty.text') }}</p>
  </div>
</template>

<script>
export default {
  name: 'BasketEmpty',
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.25rem 1.5625rem;
}

.header {
  display: block;

  font-weight: var(--font-weight-bold);
  font-size: 1.25rem;
}

.text {
  margin-bottom: 0 !important;
}
</style>
